import React, { useEffect, useRef } from "react";
import Checkbox from "components/common/InputField/Checkbox";
import Button from "components/common/Button";
import { AccountPermissions } from "types/permissions";
import { useNavigate } from "react-router-dom";
import { saveToStorage } from "helpers";
import AgentSideDrawer from "components/common/AgentSideDrawer";

type MarketingCampaignProps = {
    currentStep: string;
    setCurrentStep: (step: string) => void;
    aiAgentName: string;
    setAiAgentName: (name: string) => void;
    sourceActionTrigger: string;
    setSourceActionTrigger: (trigger: string) => void;
    handleStepConfiguration: (value: boolean) => void;
    fetchedAllChannelsSuccess: Record<string, any>;
    agentDetails: Record<string, any>;
    agentSteps: Record<string, any>;
    agentId: string;
    aiTeammateId: string;
    avatar: string;
};

const MarketingCampaign = ({
    currentStep,
    setCurrentStep,
    aiAgentName,
    setAiAgentName,
    sourceActionTrigger,
    setSourceActionTrigger,
    handleStepConfiguration,
    fetchedAllChannelsSuccess,
    agentDetails,
    agentSteps,
    agentId,
    aiTeammateId,
    avatar,
}: MarketingCampaignProps) => {
    const navigate = useNavigate();
    const modalRef = useRef<HTMLDivElement>(null);

    //  useEffect(() => {
    //      const handleClickOutside = (event: MouseEvent) => {
    //          if (
    //              modalRef.current &&
    //              !modalRef.current.contains(event.target as Node) &&
    //              currentStep
    //          ) {
    //              setCurrentStep("");
    //          }
    //      };

    //      document.addEventListener("mousedown", handleClickOutside);

    //      return () => {
    //          document.removeEventListener("mousedown", handleClickOutside);
    //      };
    //  }, [modalRef, currentStep]);

    const klaviyoConnected = fetchedAllChannelsSuccess?.channel?.find(
        (item) => item?.channel?.toLowerCase() === "klaviyo" && item?.active
    );

    const googleAdsConnected = fetchedAllChannelsSuccess?.channel?.find(
        (item) => item?.channel?.toLowerCase() === "google_ads" && item?.active
    );

    const tiktokConnected = fetchedAllChannelsSuccess?.channel?.find(
        (item) => item?.channel?.toLowerCase() === "tiktok_ads" && item?.active
    );



    const marketingConnections = [
        {
            name: "Klaviyo",
            connection: klaviyoConnected,
            key: "kvo",
            value: "klaviyo",
        },
        {
            name: "Google Ads",
            connection: googleAdsConnected,
            key: "goAds",
            value: "google_ads",
        },
        {
            name: "Tiktok",
            connection: tiktokConnected,
            key: "tko",
            value: "tiktok_ads",
        },
    ];

    return (
        <>
            {/* Select the source - action trigger */}

            <AgentSideDrawer
                open={currentStep === "source-action-tigger"}
                modalRef={modalRef}
            >
                <div className=" flex  !bg-white flex-col  font-rocGroteskMedium  ">
                    <div className="relative">
                        {" "}
                        <div className="px-6 flex justify-between py-6 items-center">
                            <p className="text-sm font-rocGroteskMedium text-slate-800">
                                Select the source - action trigger
                            </p>
                            <i
                                className="ri-close-fill text-xl text-slate-500 cursor-pointer border border-slate-200 rounded py-0 px-1"
                                onClick={() => {
                                    setCurrentStep("");
                                }}
                            ></i>
                        </div>
                        <div className="mx-6 border border-slate-200 p-4 rounded-lg">
                            <div className="space-y-4  pb-4">
                                {marketingConnections?.map((item) => (
                                    <div className="flex justify-between mb-1 ">
                                        <div className="flex items-center space-x-3">
                                            <Checkbox
                                                name={item?.name}
                                                isChecked={sourceActionTrigger === item?.value}
                                                required={!sourceActionTrigger}
                                                onChange={(evt) => {
                                                    if (!item?.connection) {
                                                        return;
                                                    }

                                                    setSourceActionTrigger(item?.value);
                                                    handleStepConfiguration(true);
                                                }}
                                                className={
                                                    "!h-4 !w-4 !rounded-[4px] checked:!bg-y-10 "
                                                }
                                            />
                                            <span
                                                className={`text-sm font-rocGroteskMedium ${
                                                    sourceActionTrigger === item?.name
                                                        ? "text-gm-50"
                                                        : "text-slate-500"
                                                }`}
                                            >
                                                {item?.name}
                                            </span>
                                        </div>

                                        {!item?.connection ? (
                                            <Button
                                                btnText="Connect"
                                                btnPermission={[
                                                    AccountPermissions.all_access,
                                                    AccountPermissions.manage_integrations,
                                                    AccountPermissions.create_ai_teammate,
                                                ]}
                                                btnClassname="!px-4 !py-2 !bg-slate-50 !w-fit"
                                                btnTextClassName="!text-b-55"
                                                disabled={false}
                                                onClick={() => {
                                                    if (agentId) {
                                                        saveToStorage(
                                                            "connectedRedirect",
                                                            `/dashboard/workforce/ai-teammate/non-active/${agentId}?currTab=2`
                                                        );
                                                    } else {
                                                        saveToStorage(
                                                            "connectedRedirect",
                                                            `/dashboard//workforce/ai-teammate/${aiTeammateId}/${agentId}?currTab=2`
                                                        );
                                                    }

                                                    saveToStorage(
                                                        "createAiAgentForm",
                                                        {
                                                            aiAgentName,
                                                            sourceActionTrigger,
                                                            agentDetails,
                                                            agentSteps,
                                                            type: "marketingCampaign",
                                                            avatar,
                                                        },
                                                        true
                                                    );

                                                    navigate(
                                                        `/dashboard/integrations?social-key=${item?.key}`
                                                    );
                                                }}
                                                icon={<i className="ri-add-fill text-b-55"></i>}
                                            />
                                        ) : (
                                            <div className="px-4 py-2 w-fit space-x-2 flex items-center h-10 rounded bg-slate-50">
                                                <i className="ri-checkbox-circle-fill text-g-60"></i>
                                                <span className="text-sm font-rocGroteskMedium text-g-60">
                                                    Connected
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </AgentSideDrawer>
        </>
    );
};

export default MarketingCampaign;
